<template>
  <div class="register-page">
    <h1>Welcome to Azadi Academy!</h1>
    <div class="register-form">
      <h2>Sign up to Azadi Academy</h2>
      <form @submit.prevent="submitForm">
        <div class="form-group">
          <label for="first-name">First name <span class="required">*</span></label>
          <input
            type="text"
            id="first-name"
            v-model="form.first_name"
            required
          />
        </div>
        <div class="form-group">
          <label for="last-name">Last name <span class="required">*</span></label>
          <input type="text" id="last-name" v-model="form.last_name" required />
        </div>
        <div class="form-group">
          <label for="phone">Phone</label>
          <input type="number" id="phone" v-model="form.phone" />
        </div>
        <div class="form-group">
          <label for="email">Email address <span class="required">*</span></label>
          <input type="email" id="email" v-model="form.email" required />
        </div>
        <div class="form-group">
          <label for="country">Select country</label>
          <select v-model="form.country" class="form-control" id="country">
            <option value="" disabled>Select a country</option>
            <option v-for="(country, index) in countries" :key="index" :value="country">
              {{ country }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label for="password">Password <span class="required">*</span></label>
          <input
            type="password"
            id="password"
            v-model="form.password"
            required
          />
        </div>
        <div class="form-group">
          <label for="confirm-password">Confirm password <span class="required">*</span></label>
          <input
            type="password"
            id="confirm-password"
            v-model="form.confirmPassword"
            required
          />
        </div>
        <div class="terms">
          <input type="checkbox" id="terms" />
          <label for="terms" class="terms-label"
            >By Signing Up, You Agree To The Azadi Academy
            <router-link :to="'/terms-conditions'" class="tnC" >Terms And Conditions</router-link> & 
            <router-link :to="'/privacy-policy'" class="tnC" >Privacy Policy</router-link> .</label
          >
        </div>
        <div class="action-btn">
          <button type="submit" class="submit-btn" :disabled="loading">
            <span v-if="!loading">Sign Up</span>
            <span v-else class="loader"></span>
          </button>
        </div>
      </form>
      <p class="loginlink"><router-link :to="{ path: '/login', query: { redirectTo: $route.query.redirectTo ? $route.query.redirectTo : ''  } }">Login with an existing account</router-link></p>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      loading: false,
      showError: false,
      countries: [
        "Afghanistan",
        "Albania",
        "Algeria",
        "Andorra",
        "Angola",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Brazil",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cabo Verde",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Colombia",
        "Comoros",
        "Congo (Congo-Brazzaville)",
        "Costa Rica",
        "Croatia",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Eswatini",
        "Ethiopia",
        "Fiji",
        "Finland",
        "France",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Greece",
        "Grenada",
        "Guatemala",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Honduras",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Mauritania",
        "Mauritius",
        "Mexico",
        "Micronesia",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Morocco",
        "Mozambique",
        "Myanmar (formerly Burma)",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "North Korea",
        "North Macedonia",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Qatar",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Korea",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Suriname",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States of America",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Vatican City",
        "Venezuela",
        "Vietnam",
        "Yemen",
        "Zambia",
        "Zimbabwe"
      ],
      form: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        country: "",
        password: "",
        confirmPassword: "",
      },
    };
  },
  computed: {
    isLoggedIn() { 
      return this.$store.getters.isAuthenticated
    }
  },
  methods: {
    ...mapActions(["Register"]),
    async submitForm() {
      if (this.form.password !== this.form.confirmPassword) {
        window.toastr.error("Password & Confirm Password should match.", null, {timeOut: 1000, positionClass: 'toast-bottom-center'});
        return;
      }
      try {
        this.loading = true;
        let userForm = new FormData();
        for (let key in this.form) {
          userForm.append(key, this.form[key])
        }
        await this.Register(userForm);
        if(this.isLoggedIn) {
          const redirectTo = this.$route.query.redirectTo;
          if (redirectTo) {
            this.$router.push(decodeURIComponent(redirectTo));
          } else {
            this.$router.push("/home");
          }
          this.showError = false
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.showError = true
      }
    },
  },
};
</script>

<style scoped>
.register-page {
  text-align: center;
}
.register-page h1 {
  padding: 4rem 0;
  background-color: #0e1332;
  color: #fff;
}
.register-form {
  margin: 2rem auto;
  max-width: 45rem;
  padding: 2rem;
  border: 1px solid;
  border-radius: 4px;
}
.register-form h2 {
  padding-bottom: 2rem;
}
.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  text-align: left;
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 800;
}
.form-group input,
.form-group select {
  width: 100%;
  background-color: #e5e5e5;
  padding: 0.5rem;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.action-btn {
  margin: 2rem 0 1rem;
  display: flex;
}
.submit-btn {
  padding: 0.6rem 2rem;
  background-color: #f0c57a;
  color: #000;
  border: 1px solid #f0ba7c;
  outline: none;
  border-radius: 0.5rem;
  font-weight: 700;
  font-size: 1rem;
  padding: 0.6rem 2rem;
  font-family: 'Gothic';
}
.terms-label {
  font-size: 0.9rem;
}
.terms {
  display: flex;
  gap: 0.6rem;
  text-align: left;
  margin: 1rem 0;
}
.tnC {
  text-decoration: underline;
  /* border-bottom: 1px dashed blue; */
  cursor: pointer;
  color: #f0ba7c;
}
.loginlink {
  text-align: left;
}
.loginlink a {
  text-decoration: underline;
  color: #f0ba7c;
}
.loginlink a:hover {
  text-decoration: underline;
}
</style>
